import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import { imageUrl } from '@helpers/common'
import { MatrixServices } from '@services/image/matrix.services'
import { AuthService, ChatService, ModalService, RestServices, SharedServices, StateServices } from '@app/services'
import { ConfigService } from '@services/config.service'
import * as moment from 'moment'

@Component({
    selector: 'app-client-detail-communication',
    templateUrl: './communication.component.html',
    styleUrls: ['../../../../stagingcss/main-body.component.css',
        './communication.component.css',
        '../../../../stagingcss/lui-select.component.css',
        '../../../../stagingcss/radial-progress.component.css'],
})

export class CommunicationComponent implements OnInit, OnDestroy {
    imageUrl = imageUrl
    en = {}
    showEN = true
    idRoom
    arrList: any[] = []
    getUserId
    pauseVideo = true
    loading = false
    timelineTags = []
    timelineTagsObj = {}
    visibleTimelineTags = []
    activeTag = ''

    jsonSettingBehavior: any = {}

    arrFormTimeline: any[] = []

    updateData: any
    arrayStaffCharge: any[] = []

    enableBehavior: any = 'false'

    deleteData
    listClinicSeenAt = []
    @ViewChildren('cellImages') cellImages: QueryList<ElementRef>

    constructor(private auth: AuthService, private router: Router, private stateServices: StateServices,
                private activatedRoute: ActivatedRoute, private restApi: RestServices, private _sharedService: SharedServices,
                public matrixServices: MatrixServices,
                public chatService: ChatService,
                private modalService: ModalService,
                public configService: ConfigService) {
        this.activatedRoute.parent.paramMap.subscribe((params: ParamMap) => {
            const id = params.get('id')
            this.idRoom = id
        })
        this.enableBehavior = this.stateServices.returnEnableBehavior()
        this.listCommunicationId(this.idRoom)

        _sharedService.changeEmitted$.subscribe(success => {
            if (success && success[0] === 'loadTimelineNew') {
                const listRoomMessage = success[1]
                this.arrList = listRoomMessage.sort(function(a, b) {
                    return b.createTime - a.createTime
                })
                this.filterTags()
                this.chatService.initList(listRoomMessage)
            }
        })

        this.activatedRoute.queryParams.subscribe(query => {
            if (query['modalId']) {
                this.modalService.emitChange(['showModalChatDetail', query['modalId'], true])
            }
        })
    }

    ngOnInit() {
        this.configService.load();
        this.getUpdate()
        this.updateDateAfterDelete()
        //get list communication
        this.chatService.initList([])
        this.chatService.getListWithCommunicationID(this.idRoom)
    }

    updateDateAfterDelete() {
        this.deleteData = this.stateServices.changeEmittedDeleteTimeline$.subscribe(res => {
            if (res) {
                this.listCommunicationId(this.idRoom)
                this.stateServices.emitChangeDeleteTimeline(null)
            }
        })
    }

    getUpdate() {
        this.stateServices.emitChangeUpdateAligner(null)
        this.updateData = this.stateServices.changeEmittedUpdateAligner$.subscribe(res => {
            if (res) {
                this.arrList = res['new']
                this.arrList.sort(function(a, b) {
                    return b['visitDate'] - a['visitDate']
                })
                this.filterTags()
                this.stateServices.emitChangeUpdateAligner(null)
            }
        })
    }

    ngOnDestroy() {
        if(this.updateData){
            this.updateData.unsubscribe()
        }
        if(this.deleteData){
            this.deleteData.unsubscribe()
        }
    }

    // convert array of message tags to object
    convertTimelineTagsObject() {
        this.timelineTagsObj = this.timelineTags.reduce(function(acc, cur, i) {
            acc[cur._id] = cur.title
            return acc
        }, {})
    }

    changeActiveTag(item) {
        if (this.activeTag == item) {
            this.activeTag = null
        } else {
            this.activeTag = item
        }
        this.filterTags()
    }

    // filter timeline by message tag
    filterTags() {
        let result = []
        if (this.activeTag && this.arrList && this.arrList.length > 0) {
            this.arrList.forEach(item => {
                if (item['tags'] && item['tags'].length > 0) {
                    if (item['tags'].indexOf(this.activeTag) != -1) {
                        result.push(item)
                    }
                }
            })
            this.visibleTimelineTags = result.map(x => Object.assign({}, x))
        } else {
            this.visibleTimelineTags = this.arrList.map(x => Object.assign({}, x))

        }

        this.visibleTimelineTags = this.visibleTimelineTags.sort(function(a, b) {
            return (b['createTime']) - (a['createTime'])
        })
        this.listClinicSeenAt = []
        this.chatService.initList(this.visibleTimelineTags)
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }

    // list timeline
    listCommunicationId(idRoom) {
        const resourceUrl = 'resource'
        const map = {}
        map[idRoom] = true
        const roomId = {}
        roomId['{"clientId":"' + idRoom + '"}'] = true
        const resourceData = this.restApi.makeResourceObject({
            status: {
                client: {
                    map,
                },
                clientCommunication: {
                    paths: roomId,
                    searches: roomId,
                },
            },
        })

        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    const user = success['user']
                    this.enableBehavior = this.stateServices.checkEnableSettingBehaviour(user['_id'])
                    const emitSakura = {}
                    emitSakura['enableBehavior'] = this.enableBehavior
                    this.stateServices.emitChangeEnableBehavior(emitSakura)
                    const arrSettingAll: any[] = success['response']['setting']['paths']['{}']
                    const findSetting = arrSettingAll.find(el => {
                        return el['_id'] == 'option'
                    })
                    if (findSetting) {
                        this.jsonSettingBehavior = findSetting
                        const tmpArrFormTimeline: any[] = this.jsonSettingBehavior['timelineForms'] ? this.jsonSettingBehavior['timelineForms'] : []
                        this.arrFormTimeline = tmpArrFormTimeline.filter(el => {
                            return !el['deleted']
                        })
                    } else {
                        this.jsonSettingBehavior = {}
                        this.arrFormTimeline = []
                    }
                    const listRoomMessage = success['response']['clientCommunication']['searches']['{"clientId":"' + idRoom + '"}']
                    this.getUserId = success['response']['staff']['paths']['{}']
                    this.arrList = listRoomMessage.sort(function(a, b) {
                        return b.visitDate - a.visitDate
                    })
                    const arrPaths: any[] = success['response']['setting']['paths']['{}']
                    const findBehavior: any = arrPaths.find(el => {
                        return el['_id'] == 'option'
                    })
                    if (findBehavior) {
                        if (this.enableBehavior == 'true') {
                            this.timelineTags = findBehavior['chatTag'] || []
                        } else {
                            this.timelineTags = []
                        }
                        this.convertTimelineTagsObject()
                    }
                    this.arrayStaffCharge = success['response']['staff']['paths']['{}']
                    this.filterTags()
                    // update Clinic Or Patient
                    this.updateClinicSeenAt(listRoomMessage)
                },
            )
        })

    }

    private updateClinicSeenAt(listClinic) {
        let actionsList = []
        for (let index = 0; index < listClinic.length; index++) {
            const element = listClinic[index]
            if (!element.clinicSeenAt && element && element.isPatientCreate) {
                actionsList.push({
                    type: 'update',
                    id: element._id,
                    collection: 'clientCommunication',
                    value: {
                        clinicSeenAt: moment().utc().valueOf(),
                        updateTime: element.updateTime,
                    },
                })
            }
        }
        if (actionsList.length > 0) {
            const resourceData = this.restApi.makeResourceObject({
                actions: actionsList,
            })
            this.auth.authToken().then(tokenReNew => {
                this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                    if (success) {
                        this.listClinicSeenAt = success['updateActions']
                    }
                })
            })
        }
    }

    // click show modall timeline
    messageModal(key) {
        if (key === 'message') {
            const arrMessage = [this.idRoom, 'showModalMessageDetailCommunication', -1, 'create', this.timelineTags]
            this._sharedService.emitChange(arrMessage)
        } else if (key === 'image') {
            const arrMessage = [this.idRoom, 'showModalImageDetailCommunication', -1, 'create', this.timelineTags]
            this._sharedService.emitChange(arrMessage)
        } else if (key === 'pdf') {
            const arrMessage = [this.idRoom, 'showModalPdfDetailCommunication', -1, 'create', this.timelineTags]
            this._sharedService.emitChange(arrMessage)
        } else if (key === 'video') {
            const arrMessage = [this.idRoom, 'showModalVideoDetailCommunication', -1, 'create', this.timelineTags]
            this._sharedService.emitChange(arrMessage)
        }
    }

    iOS() {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod',
        ].includes(navigator.platform) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client-detail/communication/communication.component.ts